import { SchemaObject } from '@augloop/types-core';
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
import { TextTile } from '@augloop/types-text';
import { DeltaBuilder } from './delta-builder';
var calculateHashIdForItem = function (itemId, parentPath) {
    if (parentPath) {
        return "".concat(parentPath.join('\\'), "-").concat(itemId);
    }
    return itemId;
};
var DeltaGenerator = /** @class */ (function () {
    function DeltaGenerator() {
        var _this = this;
        this.createTextTileDeltasFromItem = function (item, parentPath) {
            var _a;
            var createTileDeltaOp = new LogOperation({
                operationName: 'CreateTextTileDeltaFromItem',
                success: true
            }).start();
            try {
                // Validate item
                if (!item) {
                    createTileDeltaOp.success = false;
                    createTileDeltaOp.resultDescription = "Unable to create text tile delta, parent item is undefined";
                    Log.info(0x1f49148d /* tag_5srsn */, LogCategory.CoreDefault, createTileDeltaOp.stop());
                    return undefined;
                }
                if (!item.body) {
                    createTileDeltaOp.success = false;
                    createTileDeltaOp.resultDescription = "Unable to create text tile delta, parent item has undefined body";
                    Log.info(0x1f49148e /* tag_5srso */, LogCategory.CoreDefault, createTileDeltaOp.stop());
                    return undefined;
                }
                var tile = item.body;
                // Validate tile
                if (!TextTile.typeGuard(tile)) {
                    createTileDeltaOp.success = false;
                    createTileDeltaOp.resultDescription = "Unable to create text tile delta, parent item body is not proper type: expected ".concat(TextTile.getTypeName(), ", received ").concat(SchemaObject.getTypeNameFor(tile));
                    return undefined;
                }
                var hashItemId = calculateHashIdForItem(item.id, parentPath);
                // Get the last seen tile or create an empty tile as the previous state
                var lastSeenTile = (_a = _this.lastSeenTileByTileId.get(hashItemId)) !== null && _a !== void 0 ? _a : new TextTile({ content: '' });
                // Because createDelta can return undefined, only update the cache if creating the delta was successful
                var deltas = _this.createDeltas(lastSeenTile, tile);
                if (!deltas || deltas.length === 0) {
                    createTileDeltaOp.dimension0 = '0';
                    createTileDeltaOp.resultDescription = 'No delta differences found';
                }
                else {
                    // Possible values for dimension0 are 0,1,2,3,4
                    createTileDeltaOp.dimension0 = deltas.length.toString();
                    _this.lastSeenTileByTileId.set(hashItemId, tile);
                }
                Log.info(0x1f49148f /* tag_5srsp */, LogCategory.CoreDefault, createTileDeltaOp.stop());
                return deltas;
            }
            catch (error) {
                createTileDeltaOp.success = false;
                createTileDeltaOp.resultDescription = "Error creating text tile delta: ".concat(error);
                Log.info(0x1f491490 /* tag_5srsq */, LogCategory.CoreDefault, createTileDeltaOp.stop());
                return undefined;
            }
        };
        this.lastSeenTileByTileId = new Map();
        this.deltaBuilder = new DeltaBuilder();
    }
    DeltaGenerator.prototype.addItemToLocalMap = function (item, parentPath) {
        var hashItemId = calculateHashIdForItem(item.id, parentPath);
        var tile = item.body;
        if (TextTile.typeGuard(tile) && !this.lastSeenTileByTileId.has(hashItemId)) {
            this.lastSeenTileByTileId.set(hashItemId, tile);
        }
    };
    DeltaGenerator.prototype.deleteItemFromLocalMap = function (item, parentPath) {
        var hashItemId = calculateHashIdForItem(item.id, parentPath);
        if (this.lastSeenTileByTileId.has(hashItemId)) {
            this.lastSeenTileByTileId.delete(hashItemId);
        }
    };
    DeltaGenerator.prototype.createDeltas = function (oldTile, newTile) {
        return this.deltaBuilder.executeDeltaBuilderHandler(SchemaObject.getTypeNameFor(newTile), oldTile, newTile);
    };
    return DeltaGenerator;
}());
export { DeltaGenerator };
//# sourceMappingURL=delta-generator.js.map